export const toPhoneString = (s?: unknown) => {
  return s && typeof s === 'string' ? s.replace(/^(\d{3})(\d{3})(\d{3})$/, '$1 $2 $3') : ''
}

export const toNipString = (s?: unknown) => {
  return s && typeof s === 'string' ? s.replace(/^(\d{3})(\d{3})(\d{2})(\d{2})$/, '$1 $2 $3 $4') : ''
}

const numberFormat = new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' })
export const displayPrice = (price: number | string) => {
  const number = typeof price === 'string' ? Number(price) : price
  return numberFormat.format(number)
}